import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Typeahead } from 'react-bootstrap-typeahead';
import { useNavigate } from 'react-router-dom';
import {
    setLandingTabs,
    setSelectedCompany,
    setSelectedIndustry,
    setSelectedHouse,
    SetErrorStatus,
    setExport
} from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage'
import { SetTopMenuNavigation, setLeftHeadMenu, SetLeftMenuTap, setPageName, Set_TOP_NAVIGATION, Set_LEFT_MENU_NAVIGATION, Set_SUB_LEFT_MENU_NAVIGATION } from '../../Redux/Slices/CommonLocalRedux/NavigationSlice';
import { CommonBaseURl } from '../../Commonprovider/CommonProvider';
import { setIsConsolidate } from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage';
export const SearchPopUp = ({ setserchmobileview }) => {
    const dispatch = useDispatch()
    const [BaseURL] = useState(CommonBaseURl)
    const navigate = useNavigate()
    const Token = useSelector(state => state.Authenticationapi.token)
    const TopNavigateTap = useSelector(state => state.Navigation.Topnavigate)
    const ErrorStatus = useSelector(state => state.LocalValuesData.ErrorStatus)
    const activelandingtab = useSelector(state => state.LocalValuesData.LandingTabs)
    const SelectedCompany = useSelector(state => state.LocalValuesData.SelectedCompany)
    const SelectedIndustry = useSelector(state => state.LocalValuesData.SelectedIndustry)
    const SelectedHouse = useSelector(state => state.LocalValuesData.SelectedHouse)
    const SelectedLeftTab = useSelector(state => state.Navigation.LeftMenuNavigate)
    const TOP_NAVIGATION = useSelector(state => state.Navigation.TOP_NAVIGATION)
    const LEFT_MENU_NAVIGATION = useSelector(state => state.Navigation.LEFT_MENU_NAVIGATION)
    const SUB_LEFT_MENU_NAVIGATION = useSelector(state => state.Navigation.SUB_LEFT_MENU_NAVIGATION)
    const IsConsolidate = useSelector(state => state.LocalValuesData.IsConsolidate)
    const Export = useSelector(state => state.LocalValuesData.Export)
    const [selected, setSelected] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [Companies, setCompanies] = useState([])
    const UserDetails = useSelector((state) => state.LoginUserDetails.data);

    const GetSearchCompanies = async (searchText) => {
        var FunctionName;
        if (TopNavigateTap[1] == 'Company' || 'Home') {
            FunctionName = 'GetCompanySearch'
        }
        if (TopNavigateTap[1] == 'Industry') {
            FunctionName = 'GetIndustryList'
        }
        if (TopNavigateTap[1] == 'House') {
            FunctionName = 'GetHouseList'
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
        let Listed_Only = UserDetails[0]?.Listed_Only || JSON.parse(UserDetails)[0]?.Listed_Only
        if (Token != null) {
            fetch(`${BaseURL}${FunctionName}?text=${searchText}&ListedOnly=${Listed_Only}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'Authorization': 'Bearer ' + Token.access_token,
                }
            }).then((Response) => Response.json())
                .then((data) => {
                    let fetchedCompanies = JSON.parse(data)
                    setCompanies(fetchedCompanies);
                })
        }
    }


    const getPlaceholder = () => {
        switch (TopNavigateTap[1]) {
            case "Company":
            case "Home":
                return "Enter Company Name";
            case "Industry":
                return "Enter Industry Name";
            case "House":
                return "Enter House Name";
            default:
                return "Enter Company Name";
        }
    };

    const selectedCompanyFunc = (selecteddata) => {
        try {
            setserchmobileview(false)
            if (selecteddata != undefined && selecteddata.length > 0) {
                if (TopNavigateTap[1] == 'Company' || TopNavigateTap[1] == 'Home') {
                    fetch(`${BaseURL}GetCompIndName?co_code=${selecteddata[0].CO_CODE}`, {
                        method: 'GET',
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8',
                            'Authorization': 'Bearer ' + Token.access_token,
                        }
                    }).then((response) => response.json())
                        .then((data) => {
                            try {
                                if (!SelectedLeftTab) {
                                    dispatch(SetErrorStatus(false));
                                    dispatch(SetTopMenuNavigation([2, "Company"]))
                                    dispatch(setSelectedCompany(JSON.parse(data)))
                                    dispatch(setSelectedHouse(JSON.parse(data)))
                                    dispatch(setSelectedIndustry(JSON.parse(data)))
                                    dispatch(setLeftHeadMenu('General'));
                                    dispatch(SetLeftMenuTap('Background'));
                                    dispatch(setPageName('Background'));
                                    dispatch(Set_TOP_NAVIGATION('Company'));
                                    dispatch(Set_LEFT_MENU_NAVIGATION('General'));
                                    dispatch(Set_SUB_LEFT_MENU_NAVIGATION('Background'));
                                    setTimeout(() => {
                                        navigate('/Company/General/Background')
                                    }, 100);
                                }
                                else {
                                    dispatch(SetErrorStatus(false));
                                    dispatch(SetTopMenuNavigation([2, "Company"]))
                                    dispatch(setSelectedCompany(JSON.parse(data)))
                                    dispatch(setSelectedHouse(JSON.parse(data)))
                                    dispatch(setSelectedIndustry(JSON.parse(data)))
                                    setTimeout(() => {
                                        navigate(`/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`)
                                        // window.location.href = `/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`
                                    }, 100);
                                }
                                setSearchText(''); // Clear the search text
                                setSelected([]);
                            } catch (error) {
                                console.log("issue while fetch serch company", error);

                            }

                        })
                }
                if (TopNavigateTap[1] == 'Industry') {
                    if (!SelectedLeftTab) {
                        dispatch(setSelectedIndustry(selecteddata))
                        // window.location.href = `/${TopNavigateTap[1]}/General/IndustryFactSheet`;
                        navigate(`/${TopNavigateTap[1]}/General/IndustryFactSheet`)
                    } else {
                        dispatch(setSelectedIndustry(selecteddata))
                        // window.location.href = `/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`
                        navigate(`/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`)
                    }
                    setSearchText('');
                    setSelected([]);
                }
                if (TopNavigateTap[1] == 'House') {
                    if (!SelectedLeftTab) {
                        dispatch(setSelectedHouse(selecteddata))
                        navigate(`/${TopNavigateTap[1]}/General/HouseFactSheet`);
                        // window.location.href = `/${TopNavigateTap[1]}/General/HouseFactSheet`;
                    } else {
                        dispatch(setSelectedHouse(selecteddata))
                        // window.location.href = `/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`
                        navigate(`/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`);
                    }
                    setSearchText('');
                    setSelected([]);

                }
            }
        } catch (error) {
            console.log("error", error);

        }

    }
    return (
        <>
            <div
                className="modal fade show"
                style={{ display: "block" }}
                tabIndex="-1"
                role="dialog"
            // ref={modalRef}
            >
                <div className="common-div" onClick={() => setserchmobileview(false)}></div>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-body common-scroller popup-form">
                            <Typeahead
                                className={`${ErrorStatus ? "error" : ""}`}
                                id="companySearch"
                                labelKey={(option) => `${option.Name || option.CO_NAME || option.CO_CODE}`}
                                minLength={2}
                                options={Companies}
                                style={{ color: "red" }}
                                placeholder={getPlaceholder()}
                                onChange={selectedCompanyFunc}
                                value={searchText}
                                onInputChange={(query) => {
                                    setSearchText(query);
                                    GetSearchCompanies(query);
                                }}
                                selected={selected}
                                inputValue={searchText}
                                filterBy={() => true}
                                renderMenuItemChildren={(option, props) => {
                                    const label = `${option.Name || option.CO_NAME || option.CO_CODE}`;
                                    const query = props.text; // This is the current input

                                    const regex = new RegExp(`(${query})`, 'gi');
                                    const parts = label.split(regex);

                                    return (
                                        <div>
                                            {parts.map((part, index) =>
                                                regex.test(part) ? (
                                                    <strong key={index}>{part}</strong> // Bold match
                                                ) : (
                                                    <span key={index}>{part}</span> // Normal text
                                                )
                                            )}
                                        </div>
                                    );
                                }}
                            />
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="bttn-close"
                                onClick={() => setserchmobileview(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
